import { conversationTagsConstants } from '@constants/conversation-tags';
import { conversationTagsService } from '@services';

const setTags = data => {
    return { type: conversationTagsConstants.CONVERSATION_TAGS_SUCCESS, payload: data };
};

const failure = () => {
    return { type: conversationTagsConstants.CONVERSATION_TAGS_ERROR };
};

const get = () => {
    return dispatch => {
        conversationTagsService.getTags().then(
            data => dispatch(setTags(data)),
            () => dispatch(failure()),
        );
    };
};

export const conversationTagsActions = {
    get,
};
